/* ==========================================================================
   "How it's made" — phone slider.

   On phones the steps are one full-width slide each in a scroll-snap track
   (see the max-width:700px rules in how-its-made.css), so swiping works
   natively. This file only drives the bar above it: the arrows scroll one
   slide, and the "01 / 04" counter follows the scroll position. On wider
   screens the track isn't scrollable and the bar is hidden, so nothing here
   has any effect.
   ========================================================================== */
(function () {
  document.querySelectorAll('[data-fb-craft-steps]').forEach(function (track) {
    if (track.dataset.fbReady) return;
    track.dataset.fbReady = '1';

    var wrap = track.parentNode;
    var steps = Array.prototype.slice.call(track.querySelectorAll('[data-fb-craft-step]'));
    var prev = wrap.querySelector('[data-fb-craft-prev]');
    var next = wrap.querySelector('[data-fb-craft-next]');
    var current = wrap.querySelector('[data-fb-craft-current]');
    var index = 0;

    var pad = function (n) { return (n < 10 ? '0' : '') + n; };

    var update = function () {
      if (!track.clientWidth) return;
      index = Math.max(0, Math.min(steps.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      if (current) current.textContent = pad(index + 1);
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= steps.length - 1;
    };

    var go = function (i) {
      i = Math.max(0, Math.min(steps.length - 1, i));
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    };

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });

    var frame;
    track.addEventListener('scroll', function () {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();

    // Theme editor: selecting a step block slides to it.
    document.addEventListener('shopify:block:select', function (e) {
      var i = steps.indexOf(e.target);
      if (i !== -1) go(i);
    });
  });
})();
